import { render, staticRenderFns } from "./FilialStopDialog.vue?vue&type=template&id=2ec1d128&scoped=true&"
import script from "./FilialStopDialog.vue?vue&type=script&lang=js&"
export * from "./FilialStopDialog.vue?vue&type=script&lang=js&"
import style0 from "./FilialStopDialog.vue?vue&type=style&index=0&id=2ec1d128&lang=less&scoped=true&"
import style1 from "./FilialStopDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec1d128",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
